import Discounts from './Discounts';
import ProductLines from './ProductLines';
import ShippingAddress from 'containers/components/Fields/ShippingAddress';

export const getSalesOrdersCustomFields = (props) => {
    switch (props.field.id) {
        case 'idAddress':
            return (
                <ShippingAddress
                    key={props.field.id}
                    data={props.data}
                    error={props.getError?.(props.errors?.[props.field.id])}
                    fieldId={props.field.id}
                    hidden={props.field.hidden}
                    label={props.field.label}
                    mandatory={props.field.mandatory}
                    onChange={props.changeField(props.field.id)}
                    readOnly={props.field.readOnly}
                />
            );
        case 'products':
            return <ProductLines key={props.field.id} {...props} />;
        case 'salesOrderDiscounts':
            return <Discounts key={props.field.id} {...props} />;
        default:
            return null;
    }
};
